import { Component, OnInit } from '@angular/core';
import { ApplicationStateService } from '../../services/application-state.service';
import { RabbitMQService } from '../../services/rabbitmq/services/rabbitmq.service';
import { DomainConstants } from '../../constants/domain-constants';
import { Subscription } from 'rxjs';
import { find } from 'lodash';
import { TerminalsService } from 'src/app/configurator/terminals/services/terminals.service';

@Component({
    selector: 'pos-screen-state',
    templateUrl: './screen-state.component.html',
    styleUrls: ['./screen-state.component.scss']
})
export class ScreenStateComponent implements OnInit {
  isScreenOff: boolean;
  isIdle = false;


  private static readonly hideCursorAfterMilliseconds = 5000;
  private idleTimeout: any = null;
  private screenStateSubscription: Subscription;

  constructor(
    private applicationStateService: ApplicationStateService,
    private rabbitMQService: RabbitMQService,
    private terminalsService: TerminalsService
  ) {}

  ngOnInit() {
    this.applicationStateService.terminalIdUpdates.subscribe((terminalId) => {
      this.initialize();
    });
  }

  onActivity() {
    this.isIdle = false;
    if (this.isScreenOff) {
      this.clearIdleTimer();
      this.startIdleTimer();
    }
  }

  turnScreenOn() {
    if (!this.applicationStateService.terminalId) {
      return;
    }
    this.terminalsService.updateScreenState(this.applicationStateService.terminalId, DomainConstants.ScreenStatus.ON)
      .subscribe({ next: () => {} });
  }

  private initialize() {
    if (!this.applicationStateService.terminalId || !this.applicationStateService.userDetails) {
      this.isScreenOff = false;
      this.unsubscribeFromScreenState();
      return;
    }
    this.loadScreenStatus();
    this.subscribeToScreenState();
  }

  private loadScreenStatus() {
    this.terminalsService.getTerminalProperties(this.applicationStateService.terminalId).subscribe({
      next: (properties) => {
        const screenStatus = find(properties, (property) =>
          property.PropertyKey === DomainConstants.TerminalProperties.SCREEN_STATUS.Key)?.PropertyValue;
        this.isScreenOff = screenStatus === DomainConstants.ScreenStatus.OFF;
      }
    });
  }

  private subscribeToScreenState() {
    this.unsubscribeFromScreenState();
    this.screenStateSubscription = this.rabbitMQService.subscribeToScreenStateMessage$().subscribe({
      next: (message) => {
        if (this.applicationStateService.terminalId == message.Payload.TerminalId) {
          this.isScreenOff = message.Payload.ScreenStatus === DomainConstants.ScreenStatus.OFF;
          this.onActivity();
        }
      }
    });
  }

  private unsubscribeFromScreenState() {
    if (this.screenStateSubscription) {
      this.screenStateSubscription.unsubscribe();
    }
  }

  private startIdleTimer() {
    this.idleTimeout = setTimeout(() => {
      this.isIdle = true;
      this.clearIdleTimer();
    }, ScreenStateComponent.hideCursorAfterMilliseconds);
  }

  private clearIdleTimer() {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
      this.idleTimeout = null;
    }
  }
}
